import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white sm:py-20" aria-labelledby="bonus-title" data-id="element-112" data-mp="1clzecp0u5062">
      <div className="mx-auto max-w-5xl" data-id="element-113" data-mp="18l5o3ozx79a0">
        <div className="mb-4 flex justify-center" data-id="element-114" data-mp="259v4favwfttv">
          <GiftIcon className="h-10 w-10 text-gold-400" aria-hidden="true" data-id="element-115" data-mp="258k0nb2gem2r" />
        </div>
        <SectionHeading id="bonus-title" dark data-id="element-116" data-mp="20c224sxpvjyv">
          Plus <span className="text-gold-400" data-id="element-117" data-mp="1w95cii9renlf">5 professional bonuses</span>
        </SectionHeading>

        <div className="mt-10 grid gap-10 md:grid-cols-2 md:gap-8" data-id="element-118" data-mp="1ra2kbyevobuv">
          {bonuses.map(b => <article key={b.number} className="flex flex-col" data-id="element-119" data-mp="ku0azhld6v3e">
              <div className="-mx-4 overflow-hidden bg-white sm:mx-0 sm:rounded-3xl" data-id="element-120" data-mp="kvbd7cz5vuse">
                <img src={b.image} alt={`${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-121" data-mp="fu41x3xt8dgz" />
              </div>
              <div className="flex flex-1 flex-col pt-5" data-id="element-122" data-mp="1erkc8ymq885x">
                <div className="flex items-center justify-between gap-3" data-id="element-123" data-mp="1jrotwrzdf8xq">
                  <span className="rounded-lg bg-gold-400 px-3 py-1 font-display text-sm font-black uppercase text-navy-950" data-id="element-124" data-mp="15t8m0xprvce0">
                    Bonus {b.number}
                  </span>
                  <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-extrabold uppercase text-navy-950" data-id="element-125" data-mp="w35msfs25278">
                    Included FREE
                  </span>
                </div>
                <h3 className="mt-3 font-display text-xl font-black leading-tight sm:text-2xl" data-id="element-126" data-mp="n2h437rpydo0">{b.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-white/75" data-id="element-127" data-mp="r3sx7n9sxh0y">{b.body}</p>
              </div>
            </article>)}
        </div>

        <SectionCTA label="Claim my 5 free bonuses" dark data-id="element-128" data-mp="d5322d6jlrf8" />
      </div>
    </section>;
}